import apiService from './ApiService';

class DivisionService {
  async getDivisiones(idColegio = null, options = {}) {
    const params = new URLSearchParams();
    if (idColegio) params.append('idColegio', idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/division${qs ? `?${qs}` : ''}`);
    const divisiones = response?.divisiones || response?.Divisiones || response?.data || response || [];
    const items = Array.isArray(divisiones) ? divisiones : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getDivisionesActivas(idColegio = null, options = {}) {
    const params = new URLSearchParams();
    if (idColegio) params.append('idColegio', idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    const qs = params.toString();
    const response = await apiService.get(`/division/activos${qs ? `?${qs}` : ''}`);
    const divisiones = response?.divisiones || response?.Divisiones || response?.data || response || [];
    const items = Array.isArray(divisiones) ? divisiones : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getDivisionById(id) {
    const response = await apiService.get(`/division/${id}`);
    const list = response?.divisiones || response?.Divisiones || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response;
  }

  async createDivision(payload) {
    const response = await apiService.post('/division', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear la división.';
      throw new Error(msg);
    }
    return response;
  }

  async updateDivision(id, payload) {
    const response = await apiService.put(`/division/${id}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar la división.';
      throw new Error(msg);
    }
    return response;
  }

  async deleteDivision(id) {
    const response = await apiService.delete(`/division/${id}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos eliminar la división.';
      throw new Error(msg);
    }
    return response;
  }
}

const divisionService = new DivisionService();

export default divisionService;
